import { IAugmentedJQuery, IComponentController, IHttpService, IPromise, ITimeoutService } from 'angular';
import IResourceService = angular.resource.IResourceService;
import { IApiConfig } from '../../../../core/interfaces/api-config.interface';
import { IParametresSecuriteService } from '../../../../core/services/parametres-securite.service';
import { IEcranContextController } from '../../../../core/behaviors/ex-ecran-context/ex-ecran-context.behavior';
import { INotificationHandler } from '../../../../core/services/utils/notification-handler.service';

interface IEcranQlik extends IComponentController {
    titrePage: string;
    app: string;
    sheet: string;
    isapp: boolean | string | undefined
    urlContent: string;
    ecranContextCtrl: IEcranContextController;
    ecranReady: boolean;
    erreurChargement: boolean;
    fetchinginfos: boolean;
    initEcran(): void;
    getQlikEcranDetails(): IPromise<IEcranQlikDetails>;
    isQlikApp(): boolean
}

interface IEcranQlikDetails {
    titreEcran: string;
    token: string;
    src: string;
    con: string;
    proxy: string;
}

const IFRAME = {
    IFRAME_APP: 'iframe.ex-ecran-qlik-content-app',
    IFRAME_SHEET: 'iframe.ex-ecran-qlik-content-sheet'
}
const ROUTE = {
    APP: '/ecran-qlik/:app',
    SHEET: '/ecran-qlik/:app/:sheet'
}

const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

/** @ngInject */
export default function EcranQlikController($resource: IResourceService,
    $element: IAugmentedJQuery,
    $timeout: ITimeoutService,
    notificationHandler: INotificationHandler,
    parametresSecurite: IParametresSecuriteService,
    ApiConfig: IApiConfig,
    $http: IHttpService) {
    const vm: IEcranQlik = this;
    let authorizationHeader: string;

    vm.$onInit = $onInit;
    vm.initEcran = initEcran;
    vm.isQlikApp = isQlikApp;

    function $onInit() {
        initEcran();
    }

    function initEcran() {
        vm.fetchinginfos = true;
        getQlikEcranDetails()
            .then(async (ecranDetails: IEcranQlikDetails) => {
                const IFRAME_CLASS = (isQlikApp()) ? IFRAME.IFRAME_APP : IFRAME.IFRAME_SHEET
                vm.titrePage = ecranDetails.titreEcran;
                vm.erreurChargement = false;
                vm.ecranReady = true;
                const xrfkey = generateXrfKey();
                const host = ecranDetails.con.replace(/(^\w+:|^)\/\//, '')
                const proxy = ecranDetails.proxy
                const csrfToken = (await getCsrfToken(host, proxy, xrfkey))?.token

                if (proxy !== 'single') {
                    $.ajax({
                        type: 'GET',
                        url: `https://${host}/${proxy}/qrs/about?XrfKey=${xrfkey}`,
                        xhrFields: {
                            withCredentials: true
                        },
                        beforeSend: function (xhr: any) {
                            xhr.setRequestHeader('Authorization', authorizationHeader);
                            xhr.setRequestHeader('X-Qlik-Xrfkey', xrfkey);
                            if (csrfToken) {
                                xhr.setRequestHeader('qlik-csrf-token', csrfToken);
                            }

                            authorizationHeader = null;

                        },
                        success: function (data) {
                            const iframe = $element.find(IFRAME_CLASS);
                            iframe.attr('src', ecranDetails.src);
                        },
                        error: function (err) {
                            if (err.responseText) {
                                notificationHandler.erreur({ lblMessage: err.responseText, lblTitre: 'G_LBL_ERREUR' });
                            }
                        }
                    });
                } else {
                    $timeout(() => {
                        const iframe = $element.find(IFRAME_CLASS);
                        iframe.attr('src', ecranDetails.src);
                    });
                }
            })
            .catch(() => {
                vm.erreurChargement = true;
            })
            .finally(() => {
                vm.fetchinginfos = false;
            });
    }

    async function getCsrfToken(host: string, proxy: string, xrfkey: string): Promise<{
        token: string;
        body: any;
    }> {
        let csrfToken: string | undefined = undefined;
        let body: any = null
        await $http.get(`${ApiConfig.ROOT}/ecran-qlik/csrf`, {
            params: {
                host,
                proxy,
                xrfkey
            }
        }).then((response: any) => {
            csrfToken = response.data.csrfToken
            body = response.data
        }).catch((err) => {
            console.error("Erreur lors de l'obtention du CSRF Token depuis Qlik server", err)
        });

        return { token: csrfToken, body: body };
    }

    function generateXrfKey(): string {
        let result = '';
        const length = 16;
        for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    function getQlikEcranDetails(): IPromise<IEcranQlikDetails> {
        const url = (vm.sheet) ? `${ApiConfig.ROOT}${ROUTE.SHEET}` : `${ApiConfig.ROOT}${ROUTE.APP}`
        const resource = $resource(url, {
            app: vm.app,
            ...((vm?.sheet) ? { sheet: vm.sheet } : {}),
            ...parametresSecurite(vm.ecranContextCtrl.stateParams)
        }, {
            get: {
                method: 'GET',
                transformResponse: (data: string, headers: Function) => {
                    authorizationHeader = headers().authorization;
                    return JSON.parse(data);
                }
            }
        });

        return resource.get().$promise;
    }
    function isQlikApp(): boolean {
        return vm?.isapp === '1'
    }
}
